<div class="report-container">
  <div class="header-contents">
    <div class="filters-section">
      @if (dateDropdownData.length) {
        <app-custom-dropdown
          class="dropdown"
          [(ngModel)]="selectedDropDownValue"
          (selectionChange)="onDateChange($event)"
          [options]="dateDropdownData"
          trackBy="monthYear"
          label="Date"
        />
      }
      @if (keyGraphDateDropDownData.length) {
        <app-custom-dropdown
          class="dropdown"
          [(ngModel)]="selectedCharts"
          (selectionChange)="onSelectionChange($event)"
          [options]="keyGraphDateDropDownData"
          [multiselect]="true"
          [multiselecWithtApply]="true"
          trackBy="chartDesc"
          label="Quick Select"
        />
      }
    </div>
    <div class="export-container">
      <img
        class="export-icon"
        src="/assets/images/pdf.svg"
        (click)="openPopup('pdf')"
        alt="export to pdf"
        title="Export to PDF"
      />
      <img
        class="export-icon message-icon"
        (click)="openCommentsPanel()"
        src="assets/images/comments.svg"
        alt="messages"
        title="Send or Read Messages"
      />
    </div>
  </div>
  @if (showErrorPage) {
    <div class="error-page">
      <app-error-page [statusCode]="statusCode" />
    </div>
  } @else {
    @if (keygraphData.length && dataChamged) {
      <div id="pdf-table-content">
        @for (chartData of keygraphData; track chartData.chartID) {
          <div class="graph-container">
            <p class="chart-title pdf-print-row">{{ chartData?.chartDesc }}</p>
            <div class="chart-container pdf-print-row">
              <app-bar-chart
                class="chart"
                [chartId]="chartData.chartID"
                [aspectRatio]="false"
                [showxAxesLabels]="true"
                [showGrid]="false"
                [showLegend]="true"
                [barLegendText]="chartData.line_Id_1_Desc"
                [bar2LegendText]="chartData.line_Id_2_Desc"
                [legendFontSize]="16"
                [dualGraph]="true"
                [barRadius]="4"
                [xAxesLabels]="getLabelshArray(chartData.groupMemberCharts)"
                [barLabel]="chartData.line1CperiodName"
                [barData]="
                  getChartData(chartData.groupMemberCharts, 'lineId_1_Value')
                "
                [barBackgroundColors]="[secondaryChartColor]"
                [bar2Data]="
                  getChartData(chartData.groupMemberCharts, 'lineId_2_Value')
                "
                [bar2Label]="chartData.line2CPeriodName"
                [bar2BackgroundColors]="[primaryChartColor]"
              />
            </div>
          </div>
        }
      </div>
    }
  }
</div>
@if (showExcelPdfPopUp) {
  <!-- Popup Component -->
  <app-excelpdfpopup
    #pdfExcelPopup
    [mode]="mode"
    [title]="popupTitle"
    [reportTitle]="reportTitle"
    [options]="pdfOptions"
    [isPageLayoutEnabled]="isPageLayoutEnabled"
    (closeClicked)="closePopup()"
    (primaryButtonClicked)="handlePrimaryButtonClick($event)"
  >
  </app-excelpdfpopup>
}
@if (showPdfExportMessage) {
  <app-popup
    title="PDF Export"
    primaryButtonText="Close"
    [showClose]="true"
    (primaryButtonClicked)="showPdfExportMessage = false"
    (closeClicked)="showPdfExportMessage = false"
  >
    <p class="pdf-text">
      {{ pdfExportMessage }}
    </p>
    <p class="pdf-link" (click)="onShowPdf()">View PDF</p>
  </app-popup>
}
<div
  id="pdf-render-host"
  style="
    position: fixed;
    left: -10000px;
    top: 0;
    width: 1200px;
    pointer-events: none;
    visibility: hidden;
  "
></div>
